<template>
  <div>
    <b-row>
      <b-table
        ref="selectableTable"
        id="table-id"
        striped
        hover
        :busy.sync="tableIsBusy"
        :items="tableProvider"
        :fields="tableFields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
        selectable
        :select-mode="tableSelectMode"
        @row-selected="onRowSelected"
      >
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.key">
              <b-form-input
                v-if="tableFilters[field.key] != null"
                v-model="tableFilters[field.key]"
                :placeholder="'Buscar por ' + field.label"
              />
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
      </b-table>
    </b-row>
    <b-row>
      <b-col sm="5" md="5" lg="5" class="mt-1">
        <b-pagination
          v-model="tableCurrentPage"
          :total-rows="tableRowCount"
          :per-page="tablePerPage"
          first-number
          last-number
          aria-controls="table-tabela-proceda"
        ></b-pagination>
      </b-col>
      <b-col sm="4" md="4" lg="4" class="mt-2">
        <label for="perPageSelect"
          >Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de
          {{ tableRowCount }}</label
        >
      </b-col>
      <b-col sm="3" md="3" lg="3">
        <b-form-group
          label-cols-md="6"
          label="Por página"
          label-align-md="right"
          label-for="perPageSelect"
        >
          <b-form-select
            class="mt-1"
            v-model="tablePerPage"
            id="perPageSelect"
            size="sm"
            :options="tablePageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BaseAlert } from "src/components";

export default {
  name: "Edit",
  components: {
    BaseAlert,
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  data: function () {
    return {
      tableFields: [
        {
          label: "Selecionado",
          key: "selected",
          sortable: false,
        },
        {
          label: "Número de documento",
          key: "documentNumber",
          sortable: true,
        },
        {
          label: "Nome fantasia",
          key: "fantasyName",
          sortable: true,
        },
        {
          label: "Razão Social",
          key: "name",
          sortable: true,
        },
      ],
      tableFilters: {
        documentNumber: "",
        name: "",
        fantasyName: "",
      },
      tableIsBusy: false,
      tablePerPage: 5,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      tableRowCount: 0,
    };
  },
  methods: {
    tableProvider(ctx, callback) {
      console.log("tableProvider");
      this.tableIsBusy = true;

      let apiFilter = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
        documentNumber: ctx.filter.documentNumber,
        name: ctx.filter.name,
        fantasyName: ctx.filter.fantasyName,
      };

      console.log(apiFilter);
      this.$api
        .post("/shippingCompany/all/", apiFilter)
        .then((data) => {
          const items = data.data.items;
          this.tableIsBusy = false;
          this.tableRowCount = data.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.tableIsBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    onRowSelected(items) {
      this.tableSelectedItem = items;
      this.$emit("rowSelected", this.tableSelectedItem);
    },
  },
};
</script>

